import { Container, ContainerPadding } from '@volkswagen-onehub/components-core';
import React from 'react';
import { STYLED_INPUT } from '../../constants/styles-constants';

interface Props {
	children: React.ReactNode;
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
}

export function Group(props: Props) {
	const { children, paddingTop, paddingBottom } = props;

	return (
		<div
			style={{
				// Restamos los margenes laterales que tienen los inputs o las cards
				marginLeft: '-' + STYLED_INPUT.margin.left,
				marginRight: '-' + STYLED_INPUT.margin.right,
			}}
		>
			<Container stretchContent padding={{ top: paddingTop || undefined, bottom: paddingBottom || undefined }}>
				{children}
			</Container>
		</div>
	);
}
